import { render, staticRenderFns } from "./egrulRecords.vue?vue&type=template&id=6f0319b2&scoped=true&"
import script from "./egrulRecords.vue?vue&type=script&lang=js&"
export * from "./egrulRecords.vue?vue&type=script&lang=js&"
import style0 from "./egrulRecords.vue?vue&type=style&index=0&id=6f0319b2&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f0319b2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/corp-dev.1clicom.ru/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f0319b2')) {
      api.createRecord('6f0319b2', component.options)
    } else {
      api.reload('6f0319b2', component.options)
    }
    module.hot.accept("./egrulRecords.vue?vue&type=template&id=6f0319b2&scoped=true&", function () {
      api.rerender('6f0319b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/card/egrulRecords/egrulRecords.vue"
export default component.exports